import { rootApi } from '../../../../root.api'
import { CUSTOM_ANSWER_GROUP } from '../efmConstants'
import { TransformedAnswerGroupData, AnswerGroupTemplateDataState } from '../efmTypes'

const BASE_URL = 'rest/recording/answergrouptemplate'

export const efmTemplateApiSlice = rootApi.injectEndpoints({
  endpoints: builder => ({
    getAnswerGroupTemplates: builder.query<TransformedAnswerGroupData[], never | void>({
      query: () => `${BASE_URL}/`,
      transformResponse: (response: AnswerGroupTemplateDataState[]) => transformAnswerGroupTemplates(response),
      providesTags: ['TemplateData'],
    }),
    saveAnswerGroupTemplate: builder.mutation<AnswerGroupTemplateDataState, AnswerGroupTemplateDataState>({
      query: template => ({
        url: `${BASE_URL}/`,
        method: 'POST',
        body: template,
      }),
      invalidatesTags: ['TemplateData'],
    }),
  }),
  overrideExisting: false,
})

const transformAnswerGroupTemplates = (
  answerGroupData: AnswerGroupTemplateDataState[],
): TransformedAnswerGroupData[] => {
  if (!answerGroupData) {
    return [CUSTOM_ANSWER_GROUP]
  }
  const transformedAnswerGroupData = answerGroupData.map((template, index) => {
    return {
      id: index + 1,
      name: template.name,
      // default answer groups (the first 5) will have the tag "any" rather than points or percent
      scoringType: index < 5 ? null : template.scoringType.scoringTypeName,
      options: template.options.map(option => {
        return {
          id: -1,
          type: option.type,
          label: option.label,
          isDefault: option.isDefault,
          kpiPriority: option.kpiPriority,
          order: option.ordinal,
          points: option.value,
        }
      }),
    }
  })
  return transformedAnswerGroupData
}

export const {
  useGetAnswerGroupTemplatesQuery,
  useSaveAnswerGroupTemplateMutation,
} = efmTemplateApiSlice
